import React from 'react'
import { Select } from 'react-dxd-components'
import Checkbox from './Checkbox'
import Input from './Input'
import {
  ADDITIONAL_FORM_FIELD_PROPS,
  COMMON_FORM_FIELD_PROPS,
  FORM_FIELD_CONTROL_PROPS,
  InputType
} from './FORM_FIELD_PROP_TYPES'

const FormField = ({
  inputType,
  id,
  label,
  attachedLabel,
  onFocus,
  onChange,
  onBlur,
  viewValue,
  value,
  invalid,
  error,
  disabled,
  options,
  placeholder,
  detail,
  maxLength,
  minLength,
  className,
  maskOptions,
  hoverDetail
}) => {

  switch (inputType) {
    case InputType.Text:
      return <Input
        onFocus={onFocus}
        viewValue={viewValue}
        id={id}
        label={label}
        attachedLabel={attachedLabel}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        invalid={invalid}
        error={error}
        disabled={disabled}
        detail={detail}
        maxLength={maxLength}
        minLength={minLength}
        className={className}
        maskOptions={maskOptions}
        hoverDetail={hoverDetail}
      />
    case InputType.Checkbox:
      return <Checkbox
        id={id}
        label={label}
        onChange={() => onChange({ target: { value: !value } })}
        value={value}
        disabled={disabled}
      />
    case InputType.Select:
      return <Select
        id={id}
        data-testid={id}
        label={label}
        invalid={invalid}
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        options={options}
        onChange={onChange}
      />
    default:
      return <></>
  }

}

FormField.propTypes = {
  ...COMMON_FORM_FIELD_PROPS,
  ...FORM_FIELD_CONTROL_PROPS,
  ...ADDITIONAL_FORM_FIELD_PROPS
}

export default FormField
